import { FormEvent, useState } from 'react';

export function Contact() {
  const apiBase = import.meta.env.VITE_PUBLIC_API_BASE_URL || '';
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [statusMessage, setStatusMessage] = useState('');

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (!apiBase) {
      setStatus('error');
      setStatusMessage('Contact API is not configured in this environment.');
      return;
    }

    setIsSubmitting(true);
    setStatus('idle');
    setStatusMessage('');

    try {
      const res = await fetch(`${apiBase}/v1/contact`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify({
          name: form.name.trim(),
          email: form.email.trim(),
          message: form.message.trim(),
        }),
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      setStatus('success');
      setStatusMessage('Thanks. Your message was sent, and our team will reach out shortly.');
      setForm({ name: '', email: '', message: '' });
    } catch {
      setStatus('error');
      setStatusMessage('We could not send your message right now. Please try again or email us directly.');
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <section className="section contact-page">
      <div className="container">
        <div className="section-head section-head-contact reveal">
          <p className="eyebrow">Contact</p>
          <h1>Let's build something great together.</h1>
          <p>
            Tell us about your program and we will connect you with the team that can help you launch and scale.
          </p>
        </div>
        <div className="contact-card reveal reveal-delay-1">
          <form className="contact-form" onSubmit={onSubmit}>
            <h3>Send us a message</h3>
            <p>Share your goals and we will connect you with the right team member.</p>

            <label className="contact-field">
              <span>Name</span>
              <input
                type="text"
                name="name"
                autoComplete="name"
                required
                value={form.name}
                onChange={(e) => setForm((prev) => ({ ...prev, name: e.target.value }))}
              />
            </label>

            <label className="contact-field">
              <span>Email</span>
              <input
                type="email"
                name="email"
                autoComplete="email"
                required
                value={form.email}
                onChange={(e) => setForm((prev) => ({ ...prev, email: e.target.value }))}
              />
            </label>

            <label className="contact-field">
              <span>Message</span>
              <textarea
                name="message"
                rows={5}
                required
                value={form.message}
                onChange={(e) => setForm((prev) => ({ ...prev, message: e.target.value }))}
              />
            </label>

            <button className="btn btn-primary" type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Sending...' : 'Submit Message'}
            </button>

            {status !== 'idle' && (
              <p className={status === 'success' ? 'form-status success' : 'form-status error'}>{statusMessage}</p>
            )}
          </form>

          <div className="contact-item">
            <h3>Email us</h3>
            <p>
              <a href="mailto:contactus@expanseft.com">contactus@expanseft.com</a>
            </p>
          </div>
          <div className="contact-item">
            <h3>Call us</h3>
            <p>
              <a href="tel:+15166532500">(516) 653 2500</a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

